import React, { useEffect, useState } from "react";
// i18n
import { withNamespaces } from "react-i18next";
import { Container } from "reactstrap";
// Redux
import { connect } from "react-redux";
import {  withRouter } from "react-router-dom";
// Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import showNotification from "../../../../helpers/show_notification";
import DirectTransfer from "../../../../components/Transfers/Items/DirectTransfer";
import preloader from "../../../../helpers/preloader";

const DirectTransferFromMainStore = (props) => {
  const storeName = localStorage.getItem("store_name")

  useEffect(() => {
    loadAllStores();
    // loadItems()
  }, []);

 
  const [allBranches, setAllBranches] = useState([]);
  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const result = [
        { label: "None", value: "", _id: "" },
        ...response.data.filter((branch) => branch.type === "CENTRAL STORE")
      ];
      const result2 = response.data.filter((store) => store.type === "CENTRAL STORE" || store.type === "Sub Store" || store.type === "Main Store" && store.name !== storeName)
      setAllBranches(result2);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allItems, setAllItems] = useState([]);
  const loadItems = async (data) => {
    preloader(true);
    // let url = process.env.REACT_APP_BASEURL + "mainstoreitems/getformainstore";
    let url = process.env.REACT_APP_BASEURL + "items/get_mapped_items";
    const response = await postSubmitForm(url, data);
    if (response && response.status === 1) {
      const selectOptions = response.data.filter((d)=>d.is_active).map(item => ({
        // ...item,
        // item_details:{
          _id:item.item_id,
          name:item.name,
          unit_levels:item.unit_levels,
          available:item.available,
          store_available:item.store_available,
          threshold:item.threshold,
          unit_for_threshold:item.unit_for_threshold,
          category:item.category,
          sub_category:item.sub_category,
        // },
        label: item.name,
        value: item.item_id
      }));
      preloader(false);
      setAllItems(selectOptions);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };


  function loadStoreItems(data) {
    loadItems({ store_id: data._id })
  }
 
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Transfer")}
            alternateTitle={props.t("Items Transfer")}
            breadcrumbItem1={props.t("Items")}
            breadcrumbItem2={props.t("New Transfer")}
          />
              <DirectTransfer 
              allStores={allBranches}
              allItems={allItems}
              onStoreSelect={loadStoreItems}
              />

        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(DirectTransferFromMainStore))
);

